import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

interface PdpDesktopProductCodeProps {
  productCode: string | null;
  productHeight: number | null;
  productWidth: number | null;
  productWeight: number | null;
  showProductWeight: boolean;
  onInfoIconClick?: (label: string) => void;
}

export function PdpDesktopProductCode({
  productCode,
  productHeight,
  productWidth,
  productWeight,
  showProductWeight,
  onInfoIconClick,
}: PdpDesktopProductCodeProps) {
  return (
    <>
      {productCode ? (
        <PdpDesktopDetailRow label="Product Code" value={productCode} />
      ) : null}
      {productHeight ? (
        <PdpDesktopDetailRow
          label="Height"
          value={`${productHeight} mm`}
          tooltip="Height can vary in the final product."
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
      {productWidth ? (
        <PdpDesktopDetailRow
          label="Width"
          value={`${productWidth} mm`}
          tooltip="Width can vary in the final product."
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
      {showProductWeight && productWeight ? (
        <PdpDesktopDetailRow
          label="Product Weight"
          value={`${productWeight} Gram`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
    </>
  );
}
